import { Trans } from 'react-i18next';

import { invoicePanelTranslationKeys } from '../../translations';

import { StyledInfo } from './Info.styled';

type YourLoginInfoProps = {
   readonly login: string;
};

export const YourLoginInfo = (props: YourLoginInfoProps): JSX.Element => {
   return (
      <StyledInfo testId={'yourLogin'} whiteSpaces={'break-spaces'}>
         <Trans
            i18nKey={invoicePanelTranslationKeys.yourLogin}
            values={{ login: props.login }}
            components={{ bold: <strong /> }}
         />
      </StyledInfo>
   );
};
